module.exports = __webpack_public_path__ + "static/image/history/pc/202506.ver2_0_2.png?c1901dba";